<template>
  <div>
    <div>
      <img src="../../../assets/menu_first2.png" alt  width="100%" style="height:240px">
    </div>
    <div style="padding: 30px; height: 100%;">
        <el-row>
              <span style="font-size:30px;color:#749cce;font-weight:bold"> 公告详情</span>
              <hr size="1" style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px">
        </el-row>
       <el-row style="text-align: left">
          <el-button type="text" icon="el-icon-arrow-left" @click="back">回上一级</el-button>
       </el-row>
        <el-row>
          <el-col :span="18" :offset="3">
            <p style="font-size:18px;margin:10px">{{title}}</p>
            <p style="width:50px;height:2px;color:red;border-bottom:4px solid #cb9065;margin:auto"></p>
            <div v-html="contents" style="height:300px;margin-top:25px;text-align:left;text-indent: 32px;line-height:26px"></div>
            <ul class="noticeDownload">
              <li>
                附件【 <a :href="this.title+'.doc'" download=""> {{title}}.doc</a> 】下载
              </li>
            </ul>
          </el-col>
        </el-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      url: {
        notify: "/draw/notify",
        tasks: "/draw/tasks/noticeTask/award"
      },
      noticeList:true,
      table: {
        pagination: {
          currentPage: 1,
          pageSize: 1,
          total: 0
        },
        loading: true,
        data: []
      },
      filterForm: {
        data: {
          title: "",
          displayProjectName: ""
        }
      },
       contents:'',//公告的内容
       title: "",
      dialog2: {
        title: "",
        visible: false,
        checkPass: "",
        type: "show",
        data: {
          title: "",
          contents: "",
          toDesign: false,
          toConstruction: false,
          toCheckDrawing: false,
          publishDate: "",
        },
        rules: {},
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        loading: true
      }
    };
  },
  mounted() {
    this.query();
    this.query2();
  },
  methods: {
       back() {
        this.$router.go(-1)
      },
    query() {
      this.table.loading = true;
      let filterList = "";
      /* filterList += "&constructCorp="+this.$store.getters.getStorage.user.user.orgName;*/
      if (this.filterForm.data.title != "") {
        filterList += "&title=" + this.filterForm.data.title;
      }
      this.$http
        .get(
          this.url.notify +
            "?" +"id="+this.$route.query.id +
            filterList
        )
        .then(
          res => {
            if (res.body.status === 200) {
              this.table.data = res.data.result.data;
              this.table.pagination.total = res.data.result.total;
              this.contents = decodeURI(res.data.result.data[0].contents);
              this.title = decodeURI(res.data.result.data[0].title);
              this.table.loading = false;
            } else {
              this.$message.error("查询失败，请联系管理员");
            }
          },
          error => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    queryID(id) {
      this.table.loading = true;
      let filterList = "";
      /* filterList += "&constructCorp="+this.$store.getters.getStorage.user.user.orgName;*/
      if (this.filterForm.data.title != "") {
        filterList += "&title=" + this.filterForm.data.title;
      }
      this.$http
        .get(
          this.url.notify +
            "?" +"id="+id +
            filterList
        )
        .then(
          res => {
            if (res.body.status === 200) {
              this.table.data = res.data.result.data;
              this.table.pagination.total = res.data.result.total;
              this.contents = decodeURI(res.data.result.data[0].contents);
              this.table.loading = false;
            } else {
              this.$message.error("查询失败，请联系管理员");
            }
          },
          error => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    query2() {
      this.table.loading = true;
      let filterList = "";
      /* filterList += "&constructCorp="+this.$store.getters.getStorage.user.user.orgName;*/
      if (this.filterForm.data.title != "") {
        filterList += "&title=" + this.filterForm.data.title;
      }
      this.$http
        .get(
          this.url.notify +
            "?"
            +"currentPage=" +
            this.table.pagination.currentPage +
            "&pageSize=" +
            this.table.pagination.pageSize +
            filterList
        )
        .then(
          res => {
            if (res.body.status === 200) {
              this.table.data = res.data.result.data;
              this.table.pagination.total = res.data.result.total;
              this.table.loading = false;
            } else {
              this.$message.error("查询失败，请联系管理员");
            }
          },
          error => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    clean() {
      this.$refs.filterRef.resetFields();
      this.query();
    },
    pageSizeChange(pageSize) {
      //每页数量改变
      this.table.pagination.pageSize = pageSize;
      this.query();
    },
    pageChange(currentPage) {
      //翻页触发
       
      this.table.pagination.currentPage = currentPage;
      this.query();
    }
  }
};
</script>
<style scoped>
@import "../../../styles/css/notice";
</style>



// WEBPACK FOOTER //
// src/views/login/notice/noticeListat.vue